import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
export interface BvCardSubsectionSignature {
    Blocks: {
        default: [];
    };
    Element: HTMLDivElement;
}
const BvCardSubsectionComponent: TOC<BvCardSubsectionSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <div class='bv-card__subsection' ...attributes>
    {{yield}}
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvCardSubsectionComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvCard::Subsection': typeof BvCardSubsectionComponent;
        'bv-card/subsection': typeof BvCardSubsectionComponent;
    }
}
